import React, { useMemo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import {
  Alert,
  Autocomplete,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Modal,
  Tab,
  Tabs,
  TextField,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import CasesRoundedIcon from "@mui/icons-material/CasesRounded";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import SettingsApplicationsRoundedIcon from "@mui/icons-material/SettingsApplicationsRounded";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import LeaderboardRoundedIcon from "@mui/icons-material/LeaderboardRounded";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import MenuItem from "@mui/material/MenuItem";
import HomeIcon from "@mui/icons-material/Home";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import DeleteIcon from '@mui/icons-material/Delete';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Restricted from "components/Restricted";
import { useGetProyectoQuery } from "state/api";
import clienteAxios from "../../config/clienteAxios";
import axios from "axios";
import UsuariosProyectoManager from "scenes/usuariosProyectos/components/UsuariosProyectoManager";
import { canAccessUsuariosProyectos, getProyectoLabel } from "scenes/usuariosProyectos/usuariosProyectosUtils";

export default function Proyectos() {
  const [items, setItems] = React.useState([]);

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("token"));
    if (items) {
      setItems(items);
    }
  }, []);

  const rol = items.rol;
  const canManageTerrainCoordinators = ["1", "2", "6"].includes(String(rol));
  const canManageProjectUsers = canAccessUsuariosProyectos(items);

  //let proyectos = useGetProyectoQuery();
  const nav = useNavigate();
  const [data, setData] = React.useState([]);
  const [ejecutar, setEjecutar] = React.useState(true);
  const [projectTab, setProjectTab] = React.useState("activos");
  const [openCoordinadores, setOpenCoordinadores] = React.useState(false);
  const [selectedProyecto, setSelectedProyecto] = React.useState(null);
  const [coordinadoresDisponibles, setCoordinadoresDisponibles] = React.useState([]);
  const [coordinadoresSeleccionados, setCoordinadoresSeleccionados] = React.useState([]);
  const [coordinadoresLoading, setCoordinadoresLoading] = React.useState(false);
  const [coordinadoresSaving, setCoordinadoresSaving] = React.useState(false);
  const [coordinadoresMessage, setCoordinadoresMessage] = React.useState("");
  const [coordinadoresError, setCoordinadoresError] = React.useState("");
  const [openUsuariosProyecto, setOpenUsuariosProyecto] = React.useState(false);
  const [usuariosProyectoSeleccionado, setUsuariosProyectoSeleccionado] = React.useState(null);

  //Theme
  const theme = useTheme();

  //BreadCrumbs
  function handleClickBreadCrumbs(event) {
    event.preventDefault();
    console.info("You clicked a breadcrumb.");
  }

  const isNonMediumScreens = useMediaQuery("(min-width: 1200px)");

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "92%", sm: 620 },
    bgcolor: theme.palette.background.alt,
    borderRadius: 4,
    boxShadow: 24,
    p: 4,
  };

  const getTokenHeaders = () => {
    const storedToken = JSON.parse(localStorage.getItem("token") || "{}");
    const idToken = storedToken?.idToken || "";

    return {
      Authorization: idToken ? `Bearer ${idToken}` : "",
      "x-access-token": idToken,
      "Content-Type": "application/json",
      Accept: "application/json",
    };
  };

  const getCoordinatorId = (usuario) => usuario?.id ?? usuario?.idUsuario ?? usuario?.id_usuario ?? "";

  const getCoordinatorLabel = (usuario) =>
    [usuario?.nombres, usuario?.apellidos].filter(Boolean).join(" ") +
    (usuario?.email ? ` - ${usuario.email}` : "");

  const normalizeText = (value = "") =>
    String(value)
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim()
      .toLowerCase();

  const getProjectStatusValues = (proyecto) =>
    [
      proyecto?.estado,
      proyecto?.id_estado,
      proyecto?.estadoProyecto,
      proyecto?.estados,
    ].filter((value) => value !== null && value !== undefined && value !== "");

  const isProjectActive = (proyecto) => {
    return getProjectStatusValues(proyecto).some((status) => {
      const numericStatus = Number(status);
      const textStatus = normalizeText(status);

      return numericStatus === 1 || textStatus === "activo";
    });
  };

  const isProjectInactive = (proyecto) => {
    if (isProjectActive(proyecto)) return false;

    return getProjectStatusValues(proyecto).some((status) => {
      const numericStatus = Number(status);
      const textStatus = normalizeText(status);

      return (
        [0, 2, 3, 4].includes(numericStatus) ||
        textStatus === "inactivo" ||
        textStatus === "desactivado" ||
        textStatus === "finalizado" ||
        textStatus === "eliminado"
      );
    });
  };

  //DropDown Button
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openDropDown = Boolean(anchorEl);
  const handleDropDown = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseDropDown = () => {
    setAnchorEl(null);
  };

  //Routes
  const handleLinkClick = (event, message) => {
    if (message === "nuevo") {
      nav("/crearProyecto");
    }
  };

  const handleLinkAdm = (event, message) => {
    if (message === "adm") {
      nav("/adminEquipos");
    }
  };

  const handleLinkGest = (event, message) => {
    if (message === "gest") {
      nav("/gestionProyectos");
    }
  };

  const handleLinkHome = (event, message) => {
    if (message === "home") {
      nav("/inicio");
    }
  };

  const handleLinkAct = (event, message) => {
    if (message === "act") {
      nav("/actividades");
    }
  };

  const handleLinkStats = (event, message) => {
    if (message === "stats") {
      nav("/estadisticasGenerales");
    }
  };

  const handleLinkEditar = (event, message, row) => {
    let pro = JSON.stringify(row.original);
    if (message === "editar") {
      nav(`/editarProyecto?prop=${pro}`);
    }
  };

  const handleLinkUsuariosProyectos = () => {
    nav("/usuarios-proyectos");
  };

  const loadCoordinadoresProyecto = async (idProyecto) => {
    setCoordinadoresLoading(true);
    setCoordinadoresMessage("");
    setCoordinadoresError("");

    try {
      const headers = getTokenHeaders();
      const [disponiblesResponse, asignadosResponse] = await Promise.all([
        axios.get("/proyectos/coordinadores-terreno/disponibles", { headers }),
        axios.get(`/proyectos/${idProyecto}/coordinadores-terreno`, { headers }),
      ]);

      const disponibles = Array.isArray(disponiblesResponse.data?.usuarios)
        ? disponiblesResponse.data.usuarios
        : [];
      const asignados = Array.isArray(asignadosResponse.data?.coordinadores)
        ? asignadosResponse.data.coordinadores
        : [];
      const asignadosIds = new Set(asignados.map((usuario) => String(getCoordinatorId(usuario))));
      const disponiblesIds = new Set(disponibles.map((usuario) => String(getCoordinatorId(usuario))));
      const asignadosNoDisponibles = asignados.filter(
        (usuario) => !disponiblesIds.has(String(getCoordinatorId(usuario)))
      );

      setCoordinadoresDisponibles([...disponibles, ...asignadosNoDisponibles]);
      setCoordinadoresSeleccionados(
        [...disponibles, ...asignadosNoDisponibles].filter((usuario) =>
          asignadosIds.has(String(getCoordinatorId(usuario)))
        )
      );
    } catch (error) {
      setCoordinadoresDisponibles([]);
      setCoordinadoresSeleccionados([]);
      setCoordinadoresError("No se pudieron cargar los coordinadores de terreno.");
    } finally {
      setCoordinadoresLoading(false);
    }
  };

  const handleOpenCoordinadores = (row) => {
    const proyecto = row.original;

    setSelectedProyecto(proyecto);
    setOpenCoordinadores(true);
    loadCoordinadoresProyecto(proyecto.idproyectos);
  };

  const handleCloseCoordinadores = () => {
    setOpenCoordinadores(false);
    setSelectedProyecto(null);
    setCoordinadoresDisponibles([]);
    setCoordinadoresSeleccionados([]);
    setCoordinadoresMessage("");
    setCoordinadoresError("");
  };

  const handleOpenUsuariosProyecto = (row) => {
    setUsuariosProyectoSeleccionado(row.original);
    setOpenUsuariosProyecto(true);
  };

  const handleCloseUsuariosProyecto = () => {
    setOpenUsuariosProyecto(false);
    setUsuariosProyectoSeleccionado(null);
  };

  const handleGuardarCoordinadores = async () => {
    if (!selectedProyecto?.idproyectos) return;

    setCoordinadoresSaving(true);
    setCoordinadoresMessage("");
    setCoordinadoresError("");

    try {
      await axios.post(
        `/proyectos/${selectedProyecto.idproyectos}/coordinadores-terreno`,
        {
          usuarios: coordinadoresSeleccionados.map((usuario) => getCoordinatorId(usuario)),
        },
        {
          headers: getTokenHeaders(),
        }
      );

      setCoordinadoresMessage("Coordinadores de terreno actualizados correctamente.");
    } catch (error) {
      setCoordinadoresError("No se pudieron actualizar los coordinadores de terreno.");
    } finally {
      setCoordinadoresSaving(false);
    }
  };

  const handleEstado = (event, message, row) => {
let estado=1;
    let idproyecto =row.original.idproyectos
    if (message === "finalizar") {
      estado=2;
      cambiarEstado(idproyecto,estado);
    }else{
      if(message === "desactivar") {
estado=3;
cambiarEstado(idproyecto,estado);
      }else{
        estado=4;
        cambiarEstado(idproyecto,estado);
      }
    }
  };

  const handleLinkEst = (event, message, row) => {
    let pro = JSON.stringify(row.original);
    if (message === "est") {
      nav(`/estadisticas?prop=${pro}`);
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "codigo",
        header: "Código",
      },
      {
        accessorKey: "nombre",
        header: "Nombre",
      },
      {
        accessorKey: "descripcion",
        header: "Descripcion",
      },
      {
        accessorKey: "estados",
        header: "Estado",
        Cell: ({ cell }) => (
          <Box
            component="span"
            sx={{
              backgroundColor:
                cell.getValue() === "Activo" ? "green" : "firebrick",
              borderRadius: "0.25rem",
              color: "#fff",
              maxWidth: "12ch",
              p: "0.25rem",
            }}
          >
            {cell.getValue()}
          </Box>
        ),
      },
    ],
    []
  );

  const proyectos = async () => {
    try {
      const { data1 } = await axios
        .get("/proyectos")
        .then(function (response) {
          // setAlerta({})

          setData(response.data);
          setEjecutar(false);
          console.log(data);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };



  const cambiarEstado = async (id,estado) => {
    
    try {
      const { data1 } = await axios
        .put("/actualizarproyectos", {
          id: id,
          estado:estado
        })
        .then(function (response) {
       
          setEjecutar(true);
        })
        .catch(function (error) {
       
        });

      
    } catch (error) {}

    //handleOpenAlert();
  };

  const projectTabCounts = useMemo(() => {
    const items = Array.isArray(data) ? data : [];

    return {
      activos: items.filter(isProjectActive).length,
      inactivos: items.filter(isProjectInactive).length,
      todos: items.length,
    };
  }, [data]);

  const filteredProjectsByTab = useMemo(() => {
    const items = Array.isArray(data) ? data : [];

    if (projectTab === "inactivos") {
      return items.filter(isProjectInactive);
    }

    if (projectTab === "todos") {
      return items;
    }

    return items.filter(isProjectActive);
  }, [data, projectTab]);

  const emptyProjectTabMessage =
    projectTab === "inactivos"
      ? "No hay proyectos inactivos."
      : projectTab === "todos"
      ? "No hay proyectos registrados."
      : "No hay proyectos activos.";

  const handleProjectTabChange = (event, newValue) => {
    setProjectTab(newValue);
  };

  if (ejecutar) {
    proyectos();
  }

  if (!data)
    return (
      <Container component="main" maxWidth="xs">
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Container>
    );
  return (
    <Box m="1.5rem 2.5rem">
      {rol === "1" ||
      rol === "2" ||
      rol === "6" ||
      rol === "7" ||
      rol === "10" ? (
        <>
          <Box
            role="presentation"
            onClick={handleClickBreadCrumbs}
            sx={{ mb: 3 }}
          >
            <Breadcrumbs aria-label="breadcrumb">
              <Link
                underline="hover"
                sx={{ display: "flex", alignItems: "center" }}
                color="inherit"
                href="/inicio"
                onClick={(event) => handleLinkHome(event, "home")}
              >
                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                Inicio
              </Link>
              <Typography
                sx={{ display: "flex", alignItems: "center" }}
                color="text.primary"
              >
                <CasesRoundedIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                Proyectos
              </Typography>
            </Breadcrumbs>
            <Typography variant="h3" sx={{ fontWeight: "bold", mt: 2 }}>
              Proyectos
            </Typography>
            <Box
              mt="10px"
              display="grid"
              gridTemplateColumns="repeat(8, 1fr)"
              gridAutoRows="160px"
              gap="20px"
              sx={{
                "& > div": {
                  gridColumn: isNonMediumScreens ? undefined : "span 12",
                },
              }}
            >
              <Box
                gridColumn="span 2"
                gridRow="span 3"
                p="1.5rem"
                borderRadius="1.5rem"
                mt="10px"
                height="fit-content"
              >
                <Grid container>
                  <Grid item xs={12} mt={2}>
                    <Card
                      className="text-center zoom"
                      sx={{
                        borderRadius: 6,
                        boxShadow: 8,
                        bgcolor: theme.palette.background.alt,
                      }}
                    >
                      <CardContent>
                        <Grid container>
                          <Grid item xs={6}>
                            <Avatar
                              sx={{
                                width: 80,
                                height: 80,
                                bgcolor: "teal",
                                mt: 2,
                                mb: 2,
                                ml: 1,
                              }}
                            >
                              <PeopleAltRoundedIcon
                                sx={{ fontSize: 50, color: "white" }}
                              />
                            </Avatar>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              sx={{ fontSize: 16, fontWeight: "bold", mt: 2 }}
                              gutterBottom
                            >
                              Administrar Equipos
                            </Typography>
                            <Button
                              variant="contained"
                              size="lg"
                              sx={{
                                bgcolor: "teal",
                                color: "white",
                                borderRadius: 2,
                                mt: 1,
                              }}
                              fullWidth
                              onClick={(event) => handleLinkAdm(event, "adm")}
                            >
                              Iniciar
                            </Button>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={12} mt={2}>
                    <Card
                      className="text-center zoom"
                      sx={{
                        borderRadius: 6,
                        boxShadow: 8,
                        bgcolor: theme.palette.background.alt,
                      }}
                    >
                      <CardContent>
                        <Grid container>
                          <Grid item xs={6}>
                            <Avatar
                              sx={{
                                width: 80,
                                height: 80,
                                bgcolor: "teal",
                                mt: 2,
                                mb: 2,
                                ml: 1,
                              }}
                            >
                              <SettingsApplicationsRoundedIcon
                                sx={{ fontSize: 50, color: "white" }}
                              />
                            </Avatar>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              sx={{ fontSize: 16, fontWeight: "bold", mt: 2 }}
                              gutterBottom
                            >
                              Gestión de Proyectos
                            </Typography>
                            <Button
                              variant="contained"
                              size="lg"
                              sx={{
                                bgcolor: "teal",
                                color: "white",
                                borderRadius: 2,
                                mt: 1,
                              }}
                              fullWidth
                              onClick={(event) => handleLinkGest(event, "gest")}
                            >
                              Iniciar
                            </Button>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                  {canManageProjectUsers && (
                    <Grid item xs={12} mt={2}>
                      <Card
                        className="text-center zoom"
                        sx={{
                          borderRadius: 1,
                          boxShadow: 8,
                          bgcolor: theme.palette.background.alt,
                        }}
                      >
                        <CardContent>
                          <Grid container alignItems="center">
                            <Grid item xs={5}>
                              <Avatar
                                sx={{
                                  width: 72,
                                  height: 72,
                                  bgcolor: "#00695c",
                                  my: 1,
                                  ml: 1,
                                }}
                              >
                                <ManageAccountsOutlinedIcon sx={{ fontSize: 44, color: "white" }} />
                              </Avatar>
                            </Grid>
                            <Grid item xs={7}>
                              <Typography sx={{ fontSize: 16, fontWeight: "bold" }} gutterBottom>
                                Asignación de Usuarios
                              </Typography>
                              <Typography variant="caption" color="text.secondary" display="block">
                                Administra usuarios asignados a proyectos
                              </Typography>
                              <Button
                                variant="contained"
                                sx={{ bgcolor: "teal", color: "white", borderRadius: 1, mt: 1 }}
                                fullWidth
                                onClick={handleLinkUsuariosProyectos}
                              >
                                Iniciar
                              </Button>
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  )}

                  <Grid item xs={12} mt={2}>
                    <Card
                      className="text-center zoom"
                      sx={{
                        borderRadius: 6,
                        boxShadow: 8,
                        bgcolor: theme.palette.background.alt,
                      }}
                    >
                      <CardContent>
                        <Grid container>
                          <Grid item xs={6}>
                            <Avatar
                              sx={{
                                width: 80,
                                height: 80,
                                bgcolor: "teal",
                                mt: 2,
                                mb: 2,
                                ml: 1,
                              }}
                            >
                              <LeaderboardRoundedIcon
                                sx={{ fontSize: 50, color: "white" }}
                              />
                            </Avatar>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              sx={{ fontSize: 16, fontWeight: "bold", mt: 3 }}
                              gutterBottom
                            >
                              Estadísticas Generales
                            </Typography>
                            <Button
                              variant="contained"
                              size="lg"
                              sx={{
                                bgcolor: "teal",
                                color: "white",
                                borderRadius: 2,
                                mt: 1,
                              }}
                              fullWidth
                              onClick={(event) =>
                                handleLinkStats(event, "stats")
                              }
                            >
                              Iniciar
                            </Button>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </Box>

              <Box
                gridColumn="span 6"
                gridRow="span 3"
                backgroundColor={theme.palette.background.alt}
                p="1.5rem"
                borderRadius="1.5rem"
                mt="40px"
                height="fit-content"
                sx={{ boxShadow: 4 }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="h5" mt={1} sx={{ fontWeight: "bold" }}>
                      Listado de Proyectos
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box
                      container
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "flex-end",
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{ bgcolor: "teal", color: "white" }}
                        size="small"
                        onClick={(event) => handleLinkClick(event, "nuevo")}
                        style={{
                          display:
                            items.rol === "1"
                              ? "block"
                              : items.rol === "2"
                              ? "block"
                              : "none",
                        }}
                      >
                        <CreateNewFolderIcon sx={{ mr: 1 }} /> Nuevo Proyecto
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
                <Box sx={{ borderBottom: 1, borderColor: "divider", mt: 2, mb: 2 }}>
                  <Tabs
                    value={projectTab}
                    onChange={handleProjectTabChange}
                    variant={isNonMediumScreens ? "fullWidth" : "scrollable"}
                    scrollButtons
                    allowScrollButtonsMobile
                  >
                    <Tab label={`Activos (${projectTabCounts.activos})`} value="activos" />
                    <Tab label={`Inactivos (${projectTabCounts.inactivos})`} value="inactivos" />
                    <Tab label={`Todos (${projectTabCounts.todos})`} value="todos" />
                  </Tabs>
                </Box>
                {filteredProjectsByTab.length === 0 && (
                  <Alert severity="info" sx={{ mb: 2 }}>
                    {emptyProjectTabMessage}
                  </Alert>
                )}
                <MaterialReactTable
                  columns={columns}
                  data={filteredProjectsByTab}
                  localization={MRT_Localization_ES}
                  enableRowActions
                  positionActionsColumn="first"
                  renderRowActionMenuItems={({ row }) => [
                    <MenuItem
                      onClick={(event) =>
                        handleLinkEditar(event, "editar", row)
                      }
                    >
                      <EditIcon sx={{ mr: 1 }} /> <b>Editar Proyecto</b>
                    </MenuItem>,
                    <MenuItem
                      onClick={(event) => handleLinkEst(event, "est", row)}
                    >
                      <LeaderboardRoundedIcon sx={{ mr: 1 }} />
                      <b>Estadísticas</b>
                    </MenuItem>,
                    <MenuItem
                      onClick={() => handleOpenCoordinadores(row)}
                      style={{
                        display: canManageTerrainCoordinators ? "block" : "none",
                      }}
                    >
                      <PeopleAltRoundedIcon sx={{ mr: 1 }} />
                      <b>Coordinadores de Terreno</b>
                    </MenuItem>,
                    <MenuItem
                      onClick={() => handleOpenUsuariosProyecto(row)}
                      style={{ display: canManageProjectUsers ? "block" : "none" }}
                    >
                      <ManageAccountsOutlinedIcon sx={{ mr: 1 }} />
                      <b>Usuarios asignados</b>
                    </MenuItem>,
                    <MenuItem
                      onClick={(event) =>handleEstado(event, "finalizar", row)}
                      sx={{ fontWeight: "bold" }}
                    >
                      <CheckCircleOutlineOutlinedIcon sx={{ mr: 1 }} />{" "}
                      Finalizar Proyecto
                    </MenuItem>,
                    <MenuItem
                      onClick={(event) =>handleEstado(event, "desactivar", row)}
                      sx={{ fontWeight: "bold" }}
                    >
                      <BlockOutlinedIcon sx={{ mr: 1 }} /> Desactivar Proyecto
                    </MenuItem>,
                     <MenuItem
                     onClick={(event) =>handleEstado(event, "eliminar", row)}
                     sx={{ color: "#FF6347", fontWeight: "bold" }}
                   >
                     <DeleteIcon sx={{ mr: 1 }} /> Eliminar Proyecto
                   </MenuItem>
                  ]}
                  muiTopToolbarProps={{
                    sx: {
                      backgroundColor: theme.palette.background.alt,
                    },
                  }}
                  muiTableHeadCellProps={{
                    align: "center",
                    sx: {
                      backgroundColor: theme.palette.background.alt,
                    },
                  }}
                  muiBottomToolbarProps={{
                    sx: {
                      backgroundColor: theme.palette.background.alt,
                    },
                  }}
                  muiTableBodyProps={{
                    sx: {
                      "& tr:nth-of-type(odd)": {
                        backgroundColor: theme.palette.background.light,
                      },
                    },
                  }}
                  muiTableBodyCellProps={{
                    align: "center",
                  }}
                  muiTablePaperProps={{
                    elevation: 0,
                    sx: {
                      backgroundColor: theme.palette.background.alt,
                    },
                  }}
                  initialState={{
                    pagination: {
                      pageSize: 5,
                      pageIndex: 0,
                    },
                  }}
                  muiTablePaginationProps={{
                    rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
                    showFirstButton: false,
                    showLastButton: false,
                    SelectProps: {
                      native: true,
                    },
                    labelRowsPerPage: "Número de filas visibles",
                  }}
                  renderDetailPanel={({ row }) => (
                    <Box
                      sx={{
                        display: "grid",
                        margin: "auto",
                        gridTemplateColumns: "1fr 1fr",
                        width: "100%",
                      }}
                    >
                      <Typography>
                        <strong>Fecha de Inicio: </strong>
                        {row.original.fecha_inicio}
                      </Typography>
                      <Typography>
                        <strong>Fecha de Finalización: </strong>
                        {row.original.fecha_fin}
                      </Typography>
                      <Typography>
                        <strong>Socio: </strong> {row.original.nombresocios}
                      </Typography>
                    </Box>
                  )}
                />
                <Modal open={openCoordinadores} onClose={handleCloseCoordinadores}>
                  <Box sx={modalStyle}>
                    <Typography variant="h4" sx={{ fontWeight: "bold", mb: 1 }}>
                      Coordinadores de Terreno
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                      {selectedProyecto?.nombre || "Proyecto seleccionado"}
                    </Typography>

                    {coordinadoresMessage && (
                      <Alert severity="success" sx={{ mb: 2 }}>
                        {coordinadoresMessage}
                      </Alert>
                    )}
                    {coordinadoresError && (
                      <Alert severity="error" sx={{ mb: 2 }}>
                        {coordinadoresError}
                      </Alert>
                    )}

                    {coordinadoresLoading ? (
                      <Box display="flex" justifyContent="center" alignItems="center" minHeight={160}>
                        <CircularProgress />
                      </Box>
                    ) : (
                      <Autocomplete
                        multiple
                        options={coordinadoresDisponibles}
                        value={coordinadoresSeleccionados}
                        onChange={(event, newValue) => {
                          setCoordinadoresSeleccionados(newValue);
                          setCoordinadoresMessage("");
                          setCoordinadoresError("");
                        }}
                        getOptionLabel={getCoordinatorLabel}
                        isOptionEqualToValue={(option, value) =>
                          String(getCoordinatorId(option)) === String(getCoordinatorId(value))
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Seleccionar coordinadores"
                            placeholder="Nombre, apellido o email"
                          />
                        )}
                        noOptionsText="No hay coordinadores disponibles"
                      />
                    )}

                    <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 1.5 }}>
                      Puedes dejar la selección vacía para desasignar todos los coordinadores de terreno.
                    </Typography>

                    <Grid container spacing={1} justifyContent="flex-end" sx={{ mt: 3 }}>
                      <Grid item>
                        <Button variant="contained" color="error" onClick={handleCloseCoordinadores}>
                          Cancelar
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          variant="contained"
                          sx={{ bgcolor: "teal", color: "white" }}
                          onClick={handleGuardarCoordinadores}
                          disabled={coordinadoresLoading || coordinadoresSaving}
                        >
                          {coordinadoresSaving ? "Guardando..." : "Guardar"}
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Modal>
                <Dialog
                  open={openUsuariosProyecto}
                  onClose={handleCloseUsuariosProyecto}
                  fullWidth
                  maxWidth="lg"
                >
                  <DialogTitle>Usuarios asignados</DialogTitle>
                  <DialogContent dividers>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                      {getProyectoLabel(usuariosProyectoSeleccionado)}
                    </Typography>
                    {openUsuariosProyecto && usuariosProyectoSeleccionado && (
                      <UsuariosProyectoManager project={usuariosProyectoSeleccionado} />
                    )}
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleCloseUsuariosProyecto}>Cerrar</Button>
                  </DialogActions>
                </Dialog>
              </Box>
            </Box>
          </Box>
        </>
      ) : (
        <Restricted />
      )}
    </Box>
  );
}
